export default __webpack_public_path__ + "static/media/upward-arrow.be194360.svg";